import RequestHelper, {ActionAnswer, CommandData} from "../utils/RequestsHelper"
import {AxiosPromise} from "axios"

export default class SyncOrdersApi {
    public static getSettings(): AxiosPromise<ActionAnswer<ordersSettings>> {
        return RequestHelper.send("get", "syncOrders")
    }

    public static setSinceDate(value: number): AxiosPromise<ActionAnswer<number>> {
        return RequestHelper.send("post", "syncOrders&action=sinceDate", {
            value
        })
    }

    public static setAddPostingNumber2comment(value: boolean): AxiosPromise<ActionAnswer<boolean>> {
        return RequestHelper.send("post", "syncOrders&action=addPostingNumber2comment", {
            value
        })
    }

    public static setAddSendDateTime2comment(value: boolean): AxiosPromise<ActionAnswer<boolean>> {
        return RequestHelper.send("post", "syncOrders&action=addSendDateTime2comment", {
            value
        })
    }

    public static setIsMultiOrder(value: boolean): AxiosPromise<ActionAnswer<boolean>> {
        return RequestHelper.send("post", "syncOrders&action=setIsMultiOrder", {
            value
        })
    }

    public static setNoOrderIfEmptyItem(value: boolean): AxiosPromise<ActionAnswer<boolean>> {
        return RequestHelper.send("post", "syncOrders&action=setNoOrderIfEmptyItem", {
            value
        })
    }

    public static setPickShippingDate(value: boolean): AxiosPromise<ActionAnswer<boolean>> {
        return RequestHelper.send("post", "syncOrders&action=setPickShippingDate", {
            value
        })
    }

    public static setSingleExpressCustomer(value: boolean): AxiosPromise<ActionAnswer<boolean>> {
        return RequestHelper.send("post", "syncOrders&action=setSingleExpressCustomer", {
            value
        })
    }

    public static setFioInComment(value: boolean): AxiosPromise<ActionAnswer<boolean>> {
        return RequestHelper.send("post", "syncOrders&action=setFioInComment", {
            value
        })
    }

    public static setDefaultShippingMethod(value: string): AxiosPromise<ActionAnswer<string>> {
        return RequestHelper.send("post", "syncOrders&action=defaultShippingMethod", {
            value
        })
    }

    public static setOzonCustomerId(value: string): AxiosPromise<ActionAnswer<string>> {
        return RequestHelper.send("post", "syncOrders&action=setOzonCustomerId", {
            value
        })
    }

    public static setDefaultPaymentMethod(value: string): AxiosPromise<ActionAnswer<string>> {
        return RequestHelper.send("post", "syncOrders&action=defaultPaymentMethod", {
            value
        })
    }

    public static setProductSyncBy(value: string): AxiosPromise<ActionAnswer<string>> {
        return RequestHelper.send("post", "syncOrders&action=productSyncBy", {value})
    }

    public static getProductSyncBy(): AxiosPromise<ActionAnswer<string>> {
        return RequestHelper.send("get", "syncOrders&action=productSyncBy")
    }

    public static setIsDebugState(value: boolean): AxiosPromise<ActionAnswer<boolean>> {
        return RequestHelper.send("post", "syncOrders&action=isDebugState", {value})
    }

    public static setOzonStateRule(name: string, value: string): AxiosPromise<ActionAnswer<string>> {
        return RequestHelper.send("post", "syncOrders&action=ozonStateRules", {name, value})
    }

    public static setStateActionPair(state: string, action: string, model: string, eventSender: string): AxiosPromise<ActionAnswer<string>> {
        return RequestHelper.send("post", "syncOrders&action=stateActionPair", {state, action, model, eventSender})
    }

    public static setStateActionPairs(state: string, actions: readonly LabelValue[], model: string, eventSender: string): AxiosPromise<ActionAnswer<string>> {
        const actions_as_values = []
        for (const action of actions) {
            actions_as_values.push(action.value)
        }
        return RequestHelper.send("post", "syncOrders&action=stateActionPair", {
            state,
            actions: actions_as_values,
            model,
            eventSender
        })
    }

    public static delStateActionPair(state: string, model: string, eventSender: string): AxiosPromise<ActionAnswer<string>> {
        return RequestHelper.send("delete", "syncOrders&action=stateActionPair", {state, model, eventSender})
    }

    public static getOzonStateRule(name: string): AxiosPromise<ActionAnswer<string>> {
        return RequestHelper.send("post", "syncOrders&action=ozonStateRules", {name})
    }

    public static getDataAboutShopOrders(ids: number[]): AxiosPromise<ActionAnswer<{ shop_order_id: number, posting_number: string }[]>> {
        return RequestHelper.send("post", "syncOrders&action=dataShopOrders", {ids})
    }

    public static getOrdersAsList(): AxiosPromise<ActionAnswer<any[]>> {
        return RequestHelper.send("get", "syncOrders&action=getOrdersList")
    }

    public static importCustomOrder(content: string): AxiosPromise<ActionAnswer<any[]>> {
        return RequestHelper.send("post", "syncOrders&action=importCustomOrder", {content})
    }

    public static importOneDebugOrder(order_id: string): AxiosPromise<ActionAnswer> {
        return RequestHelper.send("post", "syncOrders&action=importOneDebugOrder", {order_id})
    }
}

export interface ordersSettings {
    sync_by: string,
    since_time: number,
    shopActions: LabelValue[]
    isDebugState: boolean
    stateAndActionGroupedPairs: StateAndActionGroupedPair[]
    syncOrdersCommand: CommandData
    addPostingNumber2comment: boolean
    addSendDateTime2comment: boolean
    isMultiOrder: boolean
    singleExpressCustomer: boolean
    fioInComment: boolean
    noOrderIfEmptyItem: boolean
    ozonCustomerId: string
    defaultShippingMethod: string
    defaultPaymentMethod: string
    shippingMethods: LabelValue[]
    paymentMethods: LabelValue[]

}

export interface StateAndActionGroupedPair {
    name: string,
    ozonEvents: OzonStateAndShopAction[],
    shopEvents: OzonStateAndShopAction[]
}

export interface OzonStateAndShopAction {
    ozonState: LabelValue,
    shopAction: LabelValue | LabelValue[] | undefined | null
}

export interface LabelValue {
    label: string,
    value: string
}